import { useQuery } from '@tanstack/react-query';
import expensesApi from '@/features/dashboard/expenses/api/expensesApi.ts';
import { expensesApiQueryKeys } from '@/features/dashboard/expenses/api/expensesApi.queryKeys.ts';

const useGetExpense = (tourId: string, expenseId: string | null) => {
  return useQuery({
    queryKey: expensesApiQueryKeys.byId(tourId, expenseId ?? ''),
    queryFn: () => expensesApi.getById(tourId, expenseId as string),
    enabled: !!tourId && !!expenseId,
  });
};

export default useGetExpense;
